export default __webpack_public_path__ + "img/sidebars-2fce6cab.png";